import { render, staticRenderFns } from "./PeriodChoices.vue?vue&type=template&id=44a78c69&scoped=true"
import script from "./PeriodChoices.vue?vue&type=script&lang=ts"
export * from "./PeriodChoices.vue?vue&type=script&lang=ts"
import style0 from "./PeriodChoices.vue?vue&type=style&index=0&id=44a78c69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a78c69",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/date-picker/period-choices.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fdate-picker%2FPeriodChoices.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports